import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

import {SubscriptionState} from "./types";
import SubscriptionService from "./subscription_services";

// Create a thunk to fetch subscriptions
export const fetchSubscriptions = createAsyncThunk(
    "subscriptions/fetchSubscriptions",
    async (_, {rejectWithValue}):Promise<any> => {
        try {
            // Make API request
            const data = await SubscriptionService.fetchSubscriptions();

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

// Create a thunk to fetch a subscription
export const fetchUserSubscription = createAsyncThunk(
    "subscriptions/fetchUserSubscription",
    async (_, {rejectWithValue}) => {
        try {
            // Make API request
            const data = await SubscriptionService.fetchUserSubscription();

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

// Create a thunk to initiate payment for a subscription
export const initializePayment = createAsyncThunk(
    "subscriptions/initializePayment",
    async (query:any, {rejectWithValue}) => {
        try {
            // Make API request
            const data = await SubscriptionService.initializePayment(query);

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

// Create initial state
const initialState: SubscriptionState = {
    plans: [],
    subscription: null,
    loading: false,
    error: null
};

// Create a slice for subscriptions
const subscriptionSlice = createSlice({
    name: "subscriptions",
    initialState,
    reducers: {
        // Add reducers here
        setPlans: (state, action) => {
            state.plans = action.payload;
        },
        setSubscription: (state, action) => {
            state.subscription = action.payload;
        }
    },
    extraReducers: (builder) => {
        // Add extra reducers here
        builder.addCase(fetchSubscriptions.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSubscriptions.fulfilled, (state, action) => {
            state.loading = false;
            state.plans = action.payload;
        });
        builder.addCase(fetchSubscriptions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
        builder.addCase(fetchUserSubscription.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchUserSubscription.fulfilled, (state, action) => {
            state.loading = false;
            state.subscription = action.payload;
        });
        builder.addCase(fetchUserSubscription.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
        builder.addCase(initializePayment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(initializePayment.fulfilled, (state, action) => {
            state.loading = false;
            state.subscription = action.payload;
        });
        builder.addCase(initializePayment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
    }
});

// Export actions and reducer
export const {setPlans, setSubscription} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
